import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
  standalone: true,
})
export class DurationPipe implements PipeTransform {
  transform(value: number, withLabels = true): string {
    let minutes = '';
    let seconds = '';

    if (value == null || Number.isNaN(value)) return '';

    if (withLabels) {
      if (value > 60) {
        minutes = `${Math.floor(value / 60)}MIN : `;
        seconds = `${value % 60}SEK`;
      } else {
        seconds = `${value}sek`;
      }
    } else {
      if (value > 60) {
        minutes = `${Math.floor(value / 60)} : `;
        seconds = `${value % 60}`;
        if (Number(seconds) < 10) {
          seconds = `0${seconds}`;
        }
      } else {
        minutes = `0:`;
        seconds = `${value}`;
        if (value < 10) {
          seconds = `0${seconds}`;
        }
      }
    }

    return `${minutes}${seconds}`;
  }
}
